import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { SelectField } from '../../components'
import { Button } from '../../elements'

import validate from './validate'

class AntennaForm extends Component {
    static propTypes = {
        onSubmit: PropTypes.func,
    }
    state = {
        selectedClient: "",
        selectedSite: ""
    }

    changeSiteHandler = (values) => {
        this.setState({ selectedClient: values })
    }

    changeReaderHandler = (values) => {
        this.setState({ selectedSite: values })
    }

    render() {
        const { isSubmiting, handleSubmit, onSubmit, clients, sites, readers, zones } = this.props
        let clientIds = clients.map(client => client.clientId);
        let selectedSiteIds = sites.filter(site => site.clientId == this.state.selectedClient);
        let siteIds = selectedSiteIds.map(site => site.siteId)
        let selectedReaderIds = readers.filter(reader => reader.clientId == this.state.selectedClient &&
            reader.siteId == this.state.selectedSite);
        let readerIds = selectedReaderIds.map(reader => reader.readerSn)
        let selectedZoneIds = zones.filter(zone => zone.clientId == this.state.selectedClient &&
            zone.siteId == this.state.selectedSite);
        let zoneIds = selectedZoneIds.map(zone => zone.zoneId)

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <Field
                    name="clientId"
                    label="Client Id"
                    options={clientIds}
                    disabled={isSubmiting}
                    component={SelectField}
                    onChange={this.changeSiteHandler}
                    className="field"
                />
                <Field
                    name="siteId"
                    label="Site Id"
                    options={siteIds}
                    disabled={isSubmiting}
                    component={SelectField}
                    onChange={this.changeReaderHandler}
                    className="field"
                />
                <Field
                    name="readerSn"
                    label="Reader SN"
                    options={readerIds}
                    disabled={isSubmiting}
                    component={SelectField}
                    className="field"
                />
                <Field
                    name="portNumber"
                    label="Port Number"
                    options={[1, 2, 3, 4]}
                    disabled={isSubmiting}
                    component={SelectField}
                    className="field"
                />
                <Field
                    name="zoneId"
                    label="Zone Id"
                    options={zoneIds}
                    disabled={isSubmiting}
                    component={SelectField}
                    className="field"
                />
                <Field
                    name="active"
                    label="Active"
                    options={[{ label: "Active", value: true }, { label: "Deactivated", value: false }]}
                    disabled={isSubmiting}
                    component={SelectField}
                    className="field"
                />
                <Button loading={isSubmiting} htmlType="submit" type="primary">Create</Button>
            </form>
        )
    }
}

export default reduxForm({
    form: 'antenna-form',
    validate,
})(AntennaForm)



// WEBPACK FOOTER //
// ./src/smart-components/antenna-form/index.js